import { AlertTriangle, Clock, CheckCircle } from 'lucide-react';

const PriorityBadge = ({ priority }) => {
  const styles = {
    HIGH: 'bg-red-500/20 text-red-400 border-red-500/30',
    MEDIUM: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    LOW: 'bg-green-500/20 text-green-400 border-green-500/30',
    High: 'bg-red-500/20 text-red-400 border-red-500/30',
    Medium: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    Low: 'bg-green-500/20 text-green-400 border-green-500/30',
  };

  const icons = {
    HIGH: <AlertTriangle className="w-3 h-3" />,
    MEDIUM: <Clock className="w-3 h-3" />,
    LOW: <CheckCircle className="w-3 h-3" />,
    High: <AlertTriangle className="w-3 h-3" />,
    Medium: <Clock className="w-3 h-3" />,
    Low: <CheckCircle className="w-3 h-3" />,
  };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border ${
        styles[priority] || 'bg-gray-100 text-gray-700 border-gray-200'
      }`}
    >
      {icons[priority]}
      {priority}
    </span>
  );
};

export default PriorityBadge;
